import { render, staticRenderFns } from "./home-events.vue?vue&type=template&id=0945a96b&scoped=true&"
import script from "./home-events.vue?vue&type=script&lang=js&"
export * from "./home-events.vue?vue&type=script&lang=js&"
import style0 from "./home-events.vue?vue&type=style&index=0&id=0945a96b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945a96b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Touch from 'vuetify/lib/directives/touch'
installDirectives(component, {Touch})
